import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LivonLanding from "@/pages/LivonLanding";
import { LanguageProvider } from "@/i18n/LanguageContext";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LivonLanding />} />
          </Routes>
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
